import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { useIsMobile } from '../../../hooks';
import {
  PortalOverlay,
  PortalOverlayHeader,
  PortalOverlayModal,
  PortalOverlayHeaderCloseBtn,
  HeaderText,
} from '../../ui';
import ShareMenuContainer, { ShareMenuContainerProps } from './ShareMenuContainer';
import ShareMenuContent from './ShareMenuContent';

type ShareModalProps = {
  onCloseRequest: () => void,
  render: () => React.ReactNode,
};

type ShareModalAdapterProps = {
  onCloseRequest: () => void,
  onDetailsPress: () => void,
} & ShareMenuContainerProps;

export const ShareMenuModal: React.FC<ShareModalProps> = ({
  onCloseRequest,
  render,
}) => {
  const isMobile = useIsMobile();

  return (
    <PortalOverlay name="share-modal">
      <PortalOverlayModal
        position="fullScreen"
        color={colors.redLite}
        borderRadius={isMobile ? undefined : 20}
      >
        <PortalOverlayHeader
          renderRightAction={() => (
            <PortalOverlayHeaderCloseBtn onCloseRequest={onCloseRequest} />
          )}
          renderTitle={() => (
            <Box
              justifyContent="center"
            >
              <HeaderText level={2}>Share</HeaderText>
            </Box>
          )}
          style={{
            borderBottomColor: colors.blackInBlack,
            borderBottomWidth: 0.5,
          }}
        />
        {render()}
      </PortalOverlayModal>
    </PortalOverlay>
  );
};

/**
 * Add render function to container so that the logic
 * can be reused for the new share UI per ATL-4145
 */
export const ShareModalContainerAdapter: React.FC<ShareModalAdapterProps> = props => (
  <ShareMenuModal
    onCloseRequest={props.onCloseRequest}
    render={() => (
      <ShareMenuContainer
        {...props}
        showCopyableLink
        performDirectShare={props?.performDirectShare}
        renderShareModalContent={shareMenuProps => (
          <ShareMenuContent {...shareMenuProps} onDetailsPress={props.onDetailsPress} />
        )}
      />
    )}
  />
);
